import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
const TileLocation = memo(function TileLocation2({ location, isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarTile.LocationSkeleton, {});
  }
  if (!location) {
    return null;
  }
  return /* @__PURE__ */ jsx(CarTile.Location, { location, ...props });
});
export {
  TileLocation
};
